import { isPlatformBrowser, AsyncPipe } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocaleService } from '@next/core-lib/i18n';
import { BehaviorSubject } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { NedapIntegrationService } from 'src/app/settings/services/nedap-integration.service';

@Component({
  selector: 'app-nedap-redirect',
  templateUrl: 'nedap-redirect.component.html',
  imports: [AsyncPipe],
})
export class NedapRedirectComponent implements OnInit {
  message$: BehaviorSubject<string> = new BehaviorSubject('');

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly nedapIntegrationService: NedapIntegrationService,
    private readonly localeService: LocaleService,
    @Inject(PLATFORM_ID) private readonly platformId: string,
  ) {
    this.message$.next(localeService.translate('settings.third-parties.nedap-processing'));
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.activatedRoute.queryParams.pipe(take(1)).subscribe((params) => {
        const splitted = params.state.split('_');
        if (splitted.length === 2 && params.code?.length > 0) {
          const customerId = +splitted[0];
          const locationId = +splitted[1];
          this.nedapIntegrationService
            .resolveAuthorizationCode({
              authorizationCode: params.code,
              customerId,
              locationId,
            })
            .pipe(
              catchError((error: Error) => {
                console.error(error);
                this.message$.next(error.message);
                throw error;
              }),
            )
            .subscribe((_) => {
              this.message$.next(
                this.localeService.translate('settings.third-parties.nedap-successfully-processed'),
              );
            });
        }
      });
    }
  }
}
